import React from "react";
import "./tourists.css";
const Tourists = () => {
  return (
    <div className="tourists-container">
      <div className="tourists-header p-5 text-5xl text-white font-medium text-center tracking-wide ">
        Tourists Attractions
      </div>
      <div className="tourists-content">
        <div className="doi-intanon">
          <div className="intanon-content">
            <div className="intanon-header indent-8 p-2">ดอยอินทนนท์</div>
            <hr />
            <div className="intanon-text indent-8 p-2">
              <div className="indent-8">
                ดอยอินทนนท์หลายคนน่าจะรู้จักแล้วว่าเป็นยอดเขาที่สูงสุดในประเทศไทย
                แต่จริง ๆ แล้วหลายคนไม่รู้ว่าดอยอินทนนท์
                <br />
                ยังเป็นตัวแทนของหิมาลัยในประเทศไทย
                เนื่องจากบนดอยอินทนนท์มีพืชพรรณและสัตวป่าหลายชนิดคล้ายกับบน
                <br />
                เทือกเขาหิมาลัย อย่างที่เห็นได้ชัดเลยก็พวกต้นกุหลาบพันปี
                จึงไม่แปลกที่บนยอดดอยอินทนนท์มีความหลากหลายทาง
                <br />
                ระบบนิเวศ และมีแหล่งท่องเที่ยวสวยงามอลังการกระจายตามจุดต่าง ๆ
                ไม่ว่าจะเป็นน้ำตก ภูเขา จุดชมทะเลหมอก จุดล่า
                <br />
                แสงเช้าเฝ้าแสงเย็น เรียกได้ว่า “มาวันเดียวก็เที่ยวไม่พอ”
                แต่คราวนี้มันอยู่ที่เราอยากจะไปเที่ยวแบบไหน ดังนั้นใครมีเวลา
                <br />
                น้อยก็ต้องเลือกหน่อยนะครับ
                แน่นอนว่าใครที่กำลังวางแพลนมาเชียงใหม่
                ก็ไม่ควรพลาดดอยอินทนนท์เป็นอย่างยิ่ง และ
                <br />
                ควรจดไว้ในลิสต์เป็นลำดับแรก ๆ รับรองว่าไม่มีผิดหวัง
              </div>
              <li>
                ความสวยงามของ ดอยอินทนนท์ จะอยู่ที่จุดชมวิวพระอาทิตย์ขึ้นตรงกิ่ว
                <br />
                แม่ปาน และเส้นทางศึกษาธรรมชาติกิ่วแม่ปาน
                ส่วนบนยอดสูงสุดดอยอินทนนท์จะไม่มี Landscape สวยๆ
                หากมีเวลาเหลือค่อย
                <br />
                แวะขึ้นไปถ่ายรูปป้ายสูงสุดในสยาม และเดินเส้นทางธรรมชาติอ่างกา
              </li>
              <li>
                เดือนพฤศจิกายน-ธันวาคม เป็นช่วงเวลาที่สวยที่สุด
                ป่าไม้ธรรมชาติเขียวสดงดงาม และเป็นช่วงที่กิ่วแม่ปานมี
                <br />
                โอกาสเกิดทะเลหมอกมากที่สุด
                ส่วนช่วงเดือนมกราคมอากาศหนาวจัดมีโอกาสเกิดเหมยขาบมากที่สุด
                และดอกพญาเสือ
                <br />
                โคร่งบานเยอะสุด แต่ข้อเสียคือต้นไม้บางส่วนเริ่มร่วง
                และป่าไม้ไม่ค่อยเขียวแล้ว
              </li>
              <li>
                จุดที่เกิดน้ำค้างแข็งบ่อยจริง ๆ อยู่บริเวณหน้าทางเข้ากิ่วแม่ปาน
                ไม่ใช่บนยอดสูงสุดของดอยอินทนนท์
              </li>
            </div>
          </div>
        </div>
        <div className="tourists-place1">
          <div className="tourists-place1-img1"></div>
          <div className="tourists-place1-img2"></div>
          <div className="tourists-place1-content">
            <div className="place1-header indent-8 p-4">บ้านนาเลา เชียงดาว</div>

            <hr />
            <div className="place1-text indent-8 p-4">
              <li>
                “บ้านนาเลา เชียงดาว ”
                เป็นหมู่บ้านที่เห็นวิวดอยหลวงเชียงดาวได้ใกล้ชิดที่สุด
                ซึ่งดอยหลวง
                <br />
                เชียงดาวถือเป็นเทือกเขาหินปูนที่มีความสวยงามอลังการที่สุดของไทย
                และเป็นหนึ่งในสถานที่ท้องฟ้าตอน
                <br />
                กลางมืดมาก สามารถถ่ายดาวหรือล่าช้างได้สบาย ๆ
                ถ้าใครมาตรงกับช่วงคืนเดือนมืด แนะนำให้เก็บดาวก่อน
                <br /> อย่างพึ่งรีบนอน
              </li>
              <li>
                เดือนตุลาคมหรือปลายฝนต้นหนาว
                เป็นช่วงเวลาที่เหมาะสมกับการมาชมธรรมชาติหรือถ่ายรูปแนว
                <br /> Landscape มากที่สุด เพราะเป็นช่วงที่ฝน
                ตกตอนบ่ายแล้วพอตอนเย็นแสงอาทิตย์จะกระทบหมอกเมฆฝน
                <br />
                พอดี หมอกหลังฝนจะเปลี่ยนทุก ๆ 5-10นาที
                ถ้าโชคดีอาจได้เห็นรุ้งกินน้ำ และเป็นช่วงโค้งสุดท้ายสำหรับสาย
                <br />
                ล่าทางช้างเผือก
              </li>
              <li>
                ที่พักรีสอร์ทหรือโฮมสเตย์บนหมู่บ้านนาเลา
                ไม่ว่าจะพักที่ไหนวิวก็คล้าย ๆกัน ดังนั้นเลือกเอาตามที่
                <br />
                สะดวกได้เลย ส่วนทางขึ้นก็ไม่ได้น่ากลัวอย่างที่คิด
                ถนนลาดยางตลอดทั้งสาย มีช่วงอันตราย 2 จุด ใช้ความ
                <br />
                ระมัดระวังไม่ประมาทปลอดภัยแน่นอน
              </li>
            </div>
          </div>
        </div>
        <div className="tourists-place2-container">
          <div className="tourists-place2">
            <div className="tourists-place2-content">
              <div className="place2-header indent-8 p-4">ถ้ำหลวงเชียงดาว</div>
              <hr />
              <div className="place2 indent-8 p-4">
                <li>
                  “ถ้ำหลวงเชียงดาว” มีลักษณะเป็นถ้ำทางน้ำไหล ตามซอกต่าง
                  ๆมีโพรงหรือรูน้ำ(sink hole)อยู่มากมาย
                  ด้วยระยะทางที่ยาวและออกซิเจนค่อนข้างจำกัด
                  ทำให้ปัจจุบันมีการสำรวจถ้ำไปแล้วเพียงแค่ 5,100 เมตร
                  และยังไม่ได้มีการสำรวจต่ออีกที่คาดว่าน่าจะยาวมากกว่า 8,000
                  เมตร แต่อย่างไรก็ตามส่วนที่ให้นักท่องเที่ยวเข้าไปจริง
                  ๆจะมีระยะทางเพียงแค่ 1,829 เมตร เท่านั้น ซึ่งจะแบ่งเป็น 3
                  เส้นทางเดินดังนี้
                  <br />
                  – ถ้ำพระนอน ระยะทางยาว 360 เมตร (มีแสงไฟฟ้านำทางให้
                  ไม่ต้องมีไกด์นำ) <br />– ถ้ำแก้ว ระยะทางยาว 734 เมตร
                  (ต้องใช้ตะเกียง และมีไกด์นำ) <br />– ถ้ำม้า ระยะทางยาว 735
                  เมตร (ต้องใช้ตะเกียง และมีไกด์นำ)
                </li>
                <li>
                  ถ้ำหลวงเชียงดาวเป็นถ้ำที่มีความสวยงามและยาวลำดับต้นๆของไทย
                  ซึ่งมีถ้ำพระนอนสามารถเข้าได้โดยไม่ต้องมีไกด์และมีแสงไฟฟ้าตลอดเส้นทาง
                  ส่วนถ้ำแก้วกับถ้ำม้าจะต้องมีไกด์นำทางและใช้ตะเกียงส่องทางเท่านั้น
                </li>
                <li>
                  ถ้ำหลวงเชียงดาวควรมาช่วงฤดูแล้ง หรือเดือนพฤศจิกายน-พฤษภาคม
                  เพราะเป็นช่วงที่ถ้ำพระนอนน้ำไม่ท่วม
                </li>
              </div>
            </div>
            <div className="tourists-place2-img1"></div>
            <div className="tourists-place2-img2"></div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Tourists;
